// One segment of the store's segmented controls — the look only. Two
// controls share it: the surface switcher (MarketplaceSurfaceTabs — App Store
// · Marketplace · Integrations, buttons inside one page) and the catalogue
// row (AppsCatalogueTabs — Workspace apps · App Store, links between
// two pages). Each extends this and adds its own role, element and click; the
// segment reads its state from `el.isActive` and its words from `s.label` (a
// polyglot KEY).
//
// Visual: an iOS/App-Store segmented control segment — the active one lifted
// to the house active pattern (`selected` fill + `title` text) over the
// track's own tint, never a one-off accent fill.
export const MarketplaceSegment = {
  flow: 'x',
  align: 'center',
  gap: 'X',
  // Roomier than a filter chip — this is the page's primary switch, not
  // another filter, so it carries a full type step more presence.
  minHeight: 'controlH',
  padding: '0 B',
  // The labels are `nowrap` by design, so below `mobileL` a trio's
  // max-content width (~384px plus the bar's own B inset) outgrew a 390px
  // viewport and the track clipped "Integrations" at the right edge (measured
  // 2026-09-02). Trading the B side inset for A on each segment (and A on the
  // bar) brings the whole control back inside the line, so it needs no scroll
  // gesture and no scroll affordance at all.
  '@mobileL': { padding: '0 Z', fontSize: 'Z' },
  round: 'radiusPill',
  border: 'none',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  textDecoration: 'none',
  fontSize: 'Z2',
  fontWeight: '700',
  letterSpacing: '-0.01em',
  // House active pattern — `selected` + `title`; the resting segment stays
  // transparent over the track's own tint.
  background: (el) => (el.isActive ? 'selected' : 'transparent'),
  color: (el) => (el.isActive ? 'title' : 'inactive'),
  ':hover': { color: 'title' },
  ':active': { color: 'title' },
  text: (el, s) => el.call('polyglot', s.label || '')
}
